import {
  FileText, Calendar, TrendingUp 
} from 'lucide-react';
import type {
  MenuStatus, MenuType 
} from '@/features/menus';

export const TABS = [
  {
    id: 'overview',
    label: 'Overview',
    href: '/menus',
    icon: FileText 
  },
  {
    id: 'calendar',
    label: 'Calendar View',
    href: '/menus/calendar',
    icon: Calendar 
  },
  {
    id: 'forecast',
    label: 'Demand Forecast',
    href: '/menus/forecast',
    icon: TrendingUp 
  },
] as const;

export const STATUS_TABS: readonly {
  readonly value: MenuStatus | undefined;
  readonly label: string 
}[] = [
  {
    value: undefined,
    label: 'All' 
  },
  {
    value: 'active',
    label: 'Active' 
  },
  {
    value: 'draft',
    label: 'Draft' 
  },
  {
    value: 'archived',
    label: 'Archived' 
  },
];

export const MEAL_TYPES: readonly {
  readonly value: MenuType | undefined;
  readonly label: string 
}[] = [
  {
    value: undefined,
    label: 'All Meals' 
  },
  {
    value: 'breakfast',
    label: 'Breakfast' 
  },
  {
    value: 'lunch',
    label: 'Lunch' 
  },
  {
    value: 'dinner',
    label: 'Dinner' 
  },
  {
    value: 'all-day',
    label: 'All Day' 
  },
  {
    value: 'special',
    label: 'Special' 
  },
];

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
] as const;

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export const MENU_TYPE_OPTIONS = [
  {
    value: 'breakfast',
    label: 'Breakfast' 
  },
  {
    value: 'lunch',
    label: 'Lunch' 
  },
  {
    value: 'dinner',
    label: 'Dinner' 
  },
  {
    value: 'all-day',
    label: 'All Day' 
  },
  {
    value: 'special',
    label: 'Special Event' 
  },
] as const;

export function getMenuTypeStyle(type: MenuType): string {
  switch (type) {
    case 'breakfast':
      return 'bg-amber-100 text-amber-800';
    case 'lunch':
      return 'bg-blue-100 text-blue-800';
    case 'dinner':
      return 'bg-purple-100 text-purple-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function getUtilizationStyle(utilization: number): string {
  if (utilization > 100) return 'text-red-600';
  if (utilization > 80) return 'text-amber-600';
  return 'text-green-600';
}
